import { UserDevice } from '../../../../data-access/gql-types/graphql';
import { DeviceType } from '../../types';

export const parseDevice = (userDevice: UserDevice) => {
  const newDevice: DeviceType = {
    id: userDevice.id,
    installationId: userDevice.installationId,
    isUpdating: false,
    payload: userDevice.payload
      ? { ...userDevice.payload }
      : {
          __typename: 'DeviceStateModel',
          channelInfos: [],
          connectedToSsid: '',
          macAddress: '',
          currentFirmwareVersion: '',
          deviceId: '',
          isUpdateAvailable: false,
          model: '',
          name: '',
          newestFirmwareVersion: '',
          timeZone: '',
          lastConnectedAtUtc: '',
          registeredAtUtc: '',
        },
  };
  return newDevice;
};

export const formatDeviceTypeLabel = (type: string) => {
  return type === 'GATE' ? `${type}&DOOR` : type;
};
